import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  Injector,
  ViewChild,
  inject,
} from '@angular/core';
import { PlaceholderDirective } from '@shared/directives';

@Component({
  selector: 'app-view-base',
  templateUrl: './view.base.html',
  styleUrls: ['./view.base.scss'],
  standalone: false,
})
export class ViewBaseComponent implements AfterViewInit {
  dynamicComponent: any;

  @ViewChild(PlaceholderDirective) templateHost: PlaceholderDirective;

  private cd: ChangeDetectorRef;

  constructor() {
    const injector = inject<Injector>(Injector);

    this.cd = injector.get(ChangeDetectorRef);

    // this.dynamicComponent = config.dynamicComponent;
  }

  ngAfterViewInit() {
    this.showTemplate();
    this.cd.detectChanges();
  }

  private showTemplate() {
    const hostViewContainerRef = this.templateHost.viewContainerRef;
    hostViewContainerRef.createComponent(this.dynamicComponent);
  }
}
